import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import BodyTable from '../../components/tablet/K007/BodyTable';
import BodyTablePc from '../../components/pc/K007/BodyTable';
import * as AppActions from '../../action/K007/AppActions';
import * as ComActions from '../../action/common/AppActions';
import * as authenticator from '../../logic/Authenticator';
import * as exceptionHandler from '../../logic/ExceptionHandler';
import * as commonLogic from '../../logic/CommonLogic';

/**
 * DispData
 */
class DispData extends React.Component {

  componentWillMount() {
    exceptionHandler.subscribe(this.props.ComActions);
    authenticator.TriggerUserName(this.props.ComActions);
    authenticator.checkLoginFailer(this.props);
  }

  componentDidMount() {
    let resizeTimer;

    window.addEventListener('resize', () => {
      if (resizeTimer !== false) {
        clearTimeout(resizeTimer);
      }
      resizeTimer = setTimeout(() => {
        this.reRender();
      }, INTERVAL_RESIZE_TRIGGER);
    });
  }

  componentDidUpdate() {
    if (this.props.AppData.calledWebFontAPI == false &&
      this.props.AppData.remainderAPICount == 0) {
      Ts.loadFont(); console.log('Ts.loadFont');
      this.props.AppActions.callWebFontAPI();
    }
  }

  reRender() {
    const prevIsPc = this.props.AppData.isPc;
    const nextIsPc = isPc();

    if (prevIsPc !== nextIsPc) {
      commonLogic.loadingResizeFadein();
      const state = this.props.AppData;
      sessionStorage.setItem('condition', JSON.stringify(state));
      sessionStorage.setItem('gmnID', 'K007');
      sessionStorage.setItem('recoverLastSearch', true);
      location.reload();
    }
  }

  render() {
    const actions = this.props.AppActions;
    const data = this.props.AppData;
    const comActions = this.props.ComActions;

    if (isPc()) {
      return (
        <BodyTablePc data={data} actions={actions} comactions={comActions} />
      );
    } else {
      return (
        <BodyTable data={data} actions={actions} comactions={comActions} />
      );
    }
  }
}

DispData.propTypes = {
  AppData: PropTypes.any.isRequired,
  AppActions: PropTypes.any.isRequired,
  ComActions: PropTypes.any.isRequired,
};

/**
 * mapStateToProps
 * @param {*} state
 */
function mapStateToProps(state) {
  return {
    AppData: state
  };
}

/**
 * mapDispatchToProps
 * @param {*} dispatch
 */
function mapDispatchToProps(dispatch) {
  return {
    AppActions: bindActionCreators(AppActions, dispatch),
    ComActions: bindActionCreators(ComActions, dispatch)
  };
}

/**
 * connect
 */
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DispData);
